var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.visible)?_c('ChangeRecord',{attrs:{"title":"积分变更记录","columns":_vm.columns,"data":_vm.data,"total":_vm.total,"is-show-integral-change-type":true},on:{"dataChange":_vm.dataChange,"onSearch":_vm.onSearch}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }